import { FC, ReactNode } from 'react';
import { AddressBook } from '@/types/address-book';
import { ContactList } from './contact-list';
import { CreateContactForm } from './create-contact-form';
import { UnassignAddressBookButton } from './unassign-address-book-button';

export type AddressBookBlockProps = {
  addressBook: AddressBook;
  organisationId: number;
  unitId: number;
  editEnabled: boolean;
  /** Optional content rendered between the heading and the contacts. */
  children?: ReactNode;
};

export const AddressBookBlock: FC<AddressBookBlockProps> = ({
  addressBook,
  organisationId,
  unitId,
  editEnabled,
  children,
}) => (
  <div className="flex flex-col gap-2">
    <div className="flex flex-col">
      <h4 className="font-medium">{addressBook.name}</h4>
      <span className="text-xs text-gray-500">{addressBook.addressBookId}</span>
    </div>
    {children}
    <ContactList
      addressBookId={addressBook.addressBookId}
      contacts={addressBook.contacts}
      editEnabled={editEnabled}
      organisationId={organisationId}
    />
    {editEnabled && (
      <>
        <h4 className="mt-2 font-medium">Add Contact</h4>
        <CreateContactForm addressBookId={addressBook.addressBookId} />
        <UnassignAddressBookButton
          addressBookId={addressBook.addressBookId}
          organisationId={organisationId}
          unitId={unitId}
        />
      </>
    )}
  </div>
);
